module.exports = __webpack_public_path__ + "img/image1.60b2273b.png";